import StateBase, { throwInvalidMethodCall } from "./StateBase.js";
import { AUTO_RECORD_PROP } from "../Props.js";
import Registry from "./Registry.js";
import { resetQueue } from "../Helpers.js";
class DisabledStateClass extends StateBase {
  canUndo() {
    return false;
  }
  canRedo() {
    return false;
  }
  canCheckoutTo() {
    return false;
  }
  onUndo() {
    throwInvalidMethodCall();
  }
  onRedo() {
    throwInvalidMethodCall();
  }
  onEnable(stm) {
    return stm.autoRecord ? "autoreadystate" : "readystate";
  }
  onDisable() {
    throwInvalidMethodCall();
  }
  onAutoRecordOn() {
    return {
      [AUTO_RECORD_PROP]: true
    };
  }
  onAutoRecordOff() {
    return {
      [AUTO_RECORD_PROP]: false
    };
  }
  onStartTransaction() {
    throwInvalidMethodCall();
  }
  onStopTransaction() {
    throwInvalidMethodCall();
  }
  onStopTransactionDelayed() {
    throwInvalidMethodCall();
  }
  onRejectTransaction() {
    throwInvalidMethodCall();
  }
  onResetQueue(stm, options) {
    return resetQueue(stm, options);
  }
  onModelUpdate() {
  }
  onModelInsertChild() {
  }
  onModelRemoveChild() {
  }
  onStoreModelAdd() {
  }
  onStoreModelInsert() {
  }
  onStoreModelRemove() {
  }
  onStoreRemoveAll() {
  }
}
const DisabledState = new DisabledStateClass();
var DisabledState_default = DisabledState;
Registry.registerStmState("disabledstate", DisabledState);
export {
  DisabledStateClass,
  DisabledState_default as default
};
